(() => {
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-product-gallery-track]');
    if (!track) return;
    const slides = Array.from(track.children);
    const total = slides.length;
    if (total <= 1) return;

    const prevBtn = gallery.querySelector('[data-product-gallery-prev]');
    const nextBtn = gallery.querySelector('[data-product-gallery-next]');
    const thumbs = Array.from(
      gallery.querySelectorAll('[data-product-gallery-thumb], [data-product-gallery-dot]')
    );

    let currentIndex = 0;
    let startX = 0;
    let deltaX = 0;
    let isDragging = false;

    // Play the active slide's video, pause every other one so off-screen
    // videos don't keep downloading and decoding.
    const syncVideos = () => {
      slides.forEach((slide, index) => {
        slide.querySelectorAll('video').forEach((video) => {
          if (index === currentIndex) {
            const playing = video.play();
            if (playing && typeof playing.catch === 'function') playing.catch(() => {});
          } else {
            video.pause();
          }
        });
      });
    };

    // Slides other than the first ship their media inside a <template> so the
    // browser doesn't download every gallery image up front. Hydrate the
    // active slide plus its neighbours so the next swipe is already loaded.
    const hydrate = (index) => {
      const slide = slides[(index + total) % total];
      const deferred = slide.querySelector('template[data-product-gallery-deferred]');
      if (!deferred) return;
      deferred.replaceWith(deferred.content.cloneNode(true));
    };

    const update = () => {
      hydrate(currentIndex);
      hydrate(currentIndex - 1);
      hydrate(currentIndex + 1);
      track.style.transform = `translateX(-${currentIndex * 100}%)`;
      thumbs.forEach((thumb) => {
        thumb.classList.toggle('is-active', Number(thumb.dataset.index) === currentIndex);
      });
      syncVideos();
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        currentIndex = Number(thumb.dataset.index);
        update();
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        currentIndex = currentIndex === 0 ? total - 1 : currentIndex - 1;
        update();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        currentIndex = currentIndex === total - 1 ? 0 : currentIndex + 1;
        update();
      });
    }

    track.addEventListener('pointerdown', (event) => {
      if (event.target.closest('iframe, model-viewer')) return;
      isDragging = true;
      startX = event.clientX;
      track.classList.add('is-grabbing');
      event.preventDefault();
    });

    window.addEventListener(
      'pointermove',
      (event) => {
        if (!isDragging) return;
        deltaX = event.clientX - startX;
      },
      { passive: true }
    );

    const endDrag = () => {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-grabbing');

      if (deltaX > 50) {
        currentIndex = currentIndex === 0 ? total - 1 : currentIndex - 1;
      } else if (deltaX < -50) {
        currentIndex = currentIndex === total - 1 ? 0 : currentIndex + 1;
      }

      update();
      deltaX = 0;
    };

    window.addEventListener('pointerup', endDrag, { passive: true });
    window.addEventListener('pointercancel', endDrag, { passive: true });

    slides.forEach((slide) => {
      slide.addEventListener('dragstart', (event) => event.preventDefault());
    });

    update();
    window.addEventListener('resize', update);
  });
})();
